module.exports = __webpack_public_path__ + "fonts/fontello.c6ddaf8.woff";